var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "container is-fluid" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "columns is-multiline" },
          [
            _c("div", { staticClass: "column is-9" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.isCreating = true
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "plus", size: "is-small" },
                      }),
                      _c("span", [_vm._v(" Add group")]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("ag-grid-vue", {
              staticClass: "ag-theme-alpine",
              staticStyle: { width: "100%", height: "1000px" },
              attrs: {
                "row-data": _vm.groups,
                "grid-options": _vm.gridOptions,
                pagination: true,
                "pagination-page-size": 20,
                "multi-sort-key": "ctrl",
                modules: _vm.modules,
                "row-selection": "single",
              },
              on: { "grid-ready": _vm.gridReady },
            }),
          ],
          1
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreating,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreating = $event
            },
          },
        },
        [
          _c("GroupForm", {
            attrs: {
              endusers: _vm.endusers,
              customers: _vm.customers,
              "is-submitting": _vm.isSubmitting,
            },
            on: { submit: _vm.submitCreateGroup },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditing,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditing = $event
            },
          },
        },
        [
          _c("GroupForm", {
            attrs: {
              endusers: _vm.endusers,
              customers: _vm.customers,
              "editable-group": _vm.editableGroup,
              "is-submitting": _vm.isSubmitting,
            },
            on: { submit: _vm.submitUpdateGroup },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-multiline" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c("h1", { staticClass: "title" }, [_vm._v(" Groups ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }